<div class="wait-indicator" *ngIf="dataSource && dataSource.loading">
    <mat-spinner></mat-spinner>
</div> 
<div class="">
    <!-- ADD EVENT BUTTON -->
    <button *ngIf="showAddButton" mat-fab class="add-event-button mat-warn" (click)="addNewClicked()" aria-label="Add event" [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">
        <mat-icon class="icon">add</mat-icon>
    </button>
    <!-- / ADD EVENT BUTTON -->

    <ngx-datatable
    #myTable
    class='material expandable'
    [columnMode]="'force'"
    [headerHeight]="60"
    [footerHeight]="50"
    [rowHeight]="50"
    [scrollbarV]="false"
    [rows]='rows'
    [externalPaging]="true"
        [count]="dataSource.totalNumberOfRecords"
        offset="1"
        limit="7"
        (page)="performPagination($event)"
        >
    
    <!-- Row Detail Template -->
 
    <!-- Column Templates -->
    <ngx-datatable-column
    [width]="5"
    [sortable]="true"
    [draggable]="true"
    
   >

  </ngx-datatable-column>

    <ngx-datatable-column [canAutoResize]="true" *ngFor="let field of fields" name="{{field}}" [flexGrow]="3" [minWidth]="200">
     <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span class="mobile-hidden">{{captions[field]}}</span>
     </ng-template>
  <!--   <ng-template let-row="row" let-value="value" *ngIf="columnTypes[field]===0" ngx-datatable-cell-template>
        {{value}}
      </ng-template>

      <ng-template let-row="row" let-value="value" *ngIf="columnTypes[field]===4" ngx-datatable-cell-template>
        {{ row[field] | dateFormat}}
    </ng-template> -->


    </ngx-datatable-column>


    <ngx-datatable-column [canAutoResize]="true"  [flexGrow]="1" >
    <ng-template let-value="value" let-rowIndex="rowIndex" ngx-datatable-cell-template>
        <button *ngFor="let action of actions" mat-icon-button (click)="$event.stopPropagation();performAction(action, entity)">
            <mat-icon>{{action.iconName}}</mat-icon>
        </button>
       </ng-template>
    
        </ngx-datatable-column>


 

  </ngx-datatable>


<!--
    <mat-table *ngIf="fields && fields.length > 0" class="entities-table" [dataSource]="dataSource.collectionList" matSort [@animateStagger]="{value:'50'}" wtfPerfectScrollbar>
      Columns Definitions
        <ng-container *ngFor="let field of fields" cdkColumnDef="{{field}}">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{captions[field]}}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <ng-container *ngIf="columnTypes[field]===0">
                    <p class="text-truncate">{{row[field]}}</p>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===1">
                    <mat-form-field class="w-100-p">
                        <input matInput placeholder="" type="number" value="{{row[field]}}" (change)="processValueChanged(row, field, $event)">
                    </mat-form-field>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===2">
                    <mat-slide-toggle class="mr-24" aria-label="Active" [checked]="ConvertBoolean(row[field])" (change)="changeBoolean(row, field, $event)">
                        {{row[field] ? 'Activo' : 'Inactivo'}}
                    </mat-slide-toggle>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===3">
                
                    <img class="avatar"  *ngIf="!row[field]" src="/assets/images/ecommerce/product-image-placeholder.png">
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===4">
                    <p class="w-50-p" class="text-truncate">{{ row[field] | dateFormat}}</p>
                </ng-container>
            </mat-cell>
        </ng-container>

        Buttons Column 
        <ng-container cdkColumnDef="buttons">
            <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
            <mat-cell *cdkCellDef="let entity">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button *ngFor="let action of actions" mat-icon-button (click)="$event.stopPropagation();performAction(action, entity)">
                        <mat-icon>{{action.iconName}}</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="fields"></mat-header-row>

        <mat-row *cdkRowDef="let entity; columns: columnsToShow;" [ngClass]="{'mat-light-blue-50-bg':entity == selectedRecord}" (click)="performRowClick(entity)" (dblclick)="performRowDoubleClick(entity)">
        </mat-row>
    </mat-table>

    <mat-paginator #paginator *ngIf="!hidePaginator" [length]="dataSource.totalNumberOfRecords" [pageIndex]="0" [pageSize]="10" (page)="performPagination($event)">
       
    </mat-paginator> -->
</div>
<!--
<div id="table-message" fxLayout="column" fusePerfectScrollbar *ngIf="emptyTable">
    <div id="table-message-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="table-message-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="top">
                <div class="logo">
                    <img src="../../../../assets/images/emptybox.png">
                </div>
                <div class="title">No Records to Display!</div>
                <div class="subtitle">There are not records to display at this moment.
                </div>
            </div>
        </div>
    </div>
</div>  -->
